import axios from "axios";
import {mapGetters, mapState, mapMutations } from 'vuex'
const state = {
    availabilities: [],
    zones:[]
};

const getters = {
    availabilities: state => {
        return state.availabilities
    },
    zones: state => {
        return state.zones
    }    
};

const actions = {

    createAvailability({commit}, {availability,zone}) {
        const moment = require('moment-timezone')
        const startLocal=moment(availability.start).format()
        const endLocal=moment(availability.end).format()
        const startTz = moment(startLocal).tz(zone,true).format()
        const endTz = moment(endLocal).tz(zone,true).format()
        const startUtc = moment(startTz).utc().format('YYYY-MM-DD HH:mm')
        const endUtc = moment(endTz).utc().format('YYYY-MM-DD HH:mm')
        axios.post('/api/availabilities', {
            start:startUtc,
            end: endUtc,
            name: availability.name,
            assignmentId: availability.assignmentId
         })
            .then(res => {
                commit('CREATE_AVAILABILITIES', res.data)
            }).catch(err => {
            console.log(err)
        }) 
    },
    fetchAvailabilities({commit},{id,zone}) {
        axios.get('/api/availabilities/' + id)
            .then(res => {
                var data = res.data
                var i = 0;
                for (i; i < res.data.length; i++) {
                    const moment = require('moment-timezone')
                    var startUtc = moment.utc(data[i].start).format()
                    var endUtc = moment.utc(data[i].end).format()
                    var startZone= moment(startUtc).tz(zone).format('YYYY-MM-DD HH:mm')
                    var endZone= moment(endUtc).tz(zone).format('YYYY-MM-DD HH:mm')
                    data[i].start = moment(startZone).valueOf();
                    data[i].end =moment(endZone).valueOf();
                    data[i]['timed']=true;
                    data[i]['color']='indigo accent-2'
                }
                commit('FETCH_AVAILABILITIES', data)
            }).catch(err => {
                console.log(err)
            })
    },

    deleteAvailability({commit}, availability) {
        axios.delete('/api/availabilities/' + availability.id)
            .then(res => {
                commit('DELETE_AVAILABILITIES', availability)
            }).catch(err => {
                console.log(err)
            })
    },

    updateAvailability({commit}, {availability,zone}) {
        const moment = require('moment-timezone')
        const startLocal=moment(availability.start).format()
        const endLocal=moment(availability.end).format()
        const startTz = moment(startLocal).tz(zone,true).format()
        const endTz = moment(endLocal).tz(zone,true).format()
        const startUtc = moment(startTz).utc().format('YYYY-MM-DD HH:mm')
        const endUtc = moment(endTz).utc().format('YYYY-MM-DD HH:mm')
        axios.post('/api/availabilities/' + availability.id, {
                start: startUtc,
                end: endUtc,
                name: availability.name,
            })
            .then(res => {
                commit('UPDATE_AVAILABILITIES',availability)
            }).catch(err => {
                console.log(err)
            })
    },

    fetchTimeZones({commit}) {
        axios.get('/api/timezones')
            .then(res => {
                var data = res.data;
                commit('FETCH_TIMEZONES', data)
            }).catch(err => {
                console.log(err)
            })
    }               
   
};

const mutations = {
    
    CREATE_AVAILABILITIES(state, availability) {
        const elementsIndex = state.availabilities.findIndex(item => item.id === availability.id)
        state.availabilities[elementsIndex].id= availability[0].id
    },

    FETCH_AVAILABILITIES(state, availabilities) {
        return state.availabilities = availabilities
    },

    DELETE_AVAILABILITIES(state, availability) {
        let index = state.availabilities.findIndex(item => item.id === availability.id)
        state.availabilities.splice(index, 1)
    },

    UPDATE_AVAILABILITIES(state, availability) {
        const elementsIndex = state.availabilities.findIndex(item => item.id === availability.id)
        state.availabilities[elementsIndex] = availability
    },
    FETCH_TIMEZONES(state, zones) {
        return state.zones = zones
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
